module.exports = __webpack_public_path__ + "img/email.8b5d4d59.svg";